<template>
  <div class="WhatsappChat__MessageContainer-quaMo quaMo">
    <div
      v-for="(item, i) in messages"
      :key="i"
      :class="item.type == 'user' ? 'flex justify-end' : ''"
    >
      <div 
      :id="'msg'+item.id"
      style="opacity: 1"
      class="WhatsappChat__Message-sc-1wqac52-4 kAZgZq"
       v-if="item.type == 'system'">
      <div class="WhatsappChat__Author-sc-1wqac52-3 bMIBDo">
        {{ companyName }}
      </div>
      <div class="WhatsappChat__Text-sc-1wqac52-2 iSpIQi">
        {{ item.text }}
      </div>
      <div v-if="item.link" style="margin-bottom: 20px;" class="WhatsappChat__Text-sc-1wqac52-2 asdfsdf">
        <u><a :href="item.link">{{item.link}}</a></u>
      </div>
      <div v-if="item.text2" class="WhatsappChat__Text-sc-1wqac52-2 iSpIQi">
       {{item.text2}}
      </div>
      <!-- <div v-if="item.link2" class="WhatsappChat__Text-sc-1wqac52-2 asdfsdf">
        <u><a :href="item.link2">{{item.link2}}</a></u>
      </div> --> 
      <div class="WhatsappChat__Text-sc-1wqac52-2 iSpIQi">
      </div>
      <div v-if="item.button" class="WhatsappChat__Text-sc-1wqac52-2 iusdchud">
          <ps-button 
          @click="Clicked(item.button,item.id)"
              class="w-full flex font-medium w-10 items-center justify-center"
              theme="text-textLight dark:text-textDark bg-primary-500 dark:bg-primaryDark-accent p-2 rounded-2xl">
              {{item.button}}
          </ps-button>
      </div>
      <div v-if="item.rating"  class="WhatsappChat__Text-sc-1wqac52-2 iusdchud">

          <rating-selected @clickRating="clickRating" v-if="chatbotrating" ref="rating_system"  :grade="0" :maxStars="5" :hasCounter="true" />
           <rating v-else :grade="star" :maxStars="5" :hasCounter="true" />
      </div>

      <div class="WhatsappChat__Time-sc-1wqac52-5 cqCDVm">
        {{ time }}
      </div>
      <div 
      style="opacity: 1"
      class="WhatsappChat__Message-sc-1wqac52-4 yughbh"
       v-if="item.options">
      <div @click="clickOptions(index,item.id)" v-for="(data,index) in item.options" :key="index" class="WhatsappChat__Text-sc-1wqac52-2 ghvhjb">
        {{ data }}
      </div>
      </div>
      </div>
    <div 
      :id="'msg'+item.id"
      style="opacity: 1"
      class="WhatsappChat__Message-sc-1wqac52-4 gjgjgjgj"
       v-else>
      <div class="WhatsappChat__Author-sc-1wqac52-3 bMIBDo">
        {{ companyName }}
      </div>
      <div class="WhatsappChat__Text-sc-1wqac52-2 iSpIQi">
        {{ item.text }}
      </div>
      <div class="WhatsappChat__Time-sc-1wqac52-5 cqCDVm">
        {{ time }}
      </div>
      </div>
    </div>
  </div>
</template>
<script>
import router from "@/router";
import PsButton from '@/components/core/buttons/PsButton.vue';
import Rating from '@/components/core/rating/Rating.vue';
import RatingSelected from '@/components/core/rating/RatingSelected.vue';
export default {
  components:{
    PsButton,
    Rating,
    RatingSelected
  },
  data(){
     return{
      chatbotrating:true,
      star:0
     }
  },
  props: {
    messages: {
      type: Array,
      required: true,
    },
    companyName: {
      type: String,
      default: "",
    },
  },
  computed: {
    time() {
      return new Date().getHours() + ":" + new Date().getMinutes();
    },
  },
  methods:{
clickRating(star){
  this.star = star
this.chatbotrating = false
this.clickOptions(star,8)
},
    Clicked(text,id) {
      if(text == "SignUp"){
      this.$emit("HandelClick",text,id)
            router.push({
                name: "register",
            });
      }
      if(text == "Reset"){
      this.$emit("HandelClick",text,id)
      }
        },
    clickOptions(index,id){
      console.log(index,id,"jay-==-123")
      this.$emit("HandelClick",index,id)
    }
  }
};
</script>
